import React from 'react';
import {connect} from 'react-redux'
import {Field} from 'redux-form/immutable';
import {reduxForm} from 'redux-form/immutable';
import {Modal, Button} from 'antd';
import {TextField, DatePickerField} from 'redux-form-antd'
import {
    openModal,
    chageModal,
    closeModal
} from "../../../actions";
import {
    editApplicationForAdmission,
    updateApplicationForAdmission
} from "../../../actions/ApplicationForAdmissionAction";


const formItemLayout = {
    labelCol: {
        xs: {span: 24},
        sm: {span: 5},
    },
    wrapperCol: {
        xs: {span: 24},
        sm: {span: 19},
    },
};
let FamilyMembersModal = props => {
    const {modalIsOpen, closeModal} = props;
    const {handleSubmit} = props;
    return (
        <Modal
            title={'其他家庭成員'}
            visible={modalIsOpen}
            onCancel={() => closeModal('family_members_modal')}
            footer={null}
        >
            <form onSubmit={handleSubmit} noValidate>
                <Field {...formItemLayout} component={TextField} label="稱謂"
                       name="family_relation" type="text"></Field>
                <Field {...formItemLayout} component={TextField} label="姓名"
                       name="family_name" type="text"></Field>
                <Field {...formItemLayout} component={DatePickerField} label="出生年月日"
                       name="family_birthday"></Field>
                <Field {...formItemLayout} component={TextField} label="教育程度"
                       name="family_education" type="text"></Field>
                <Field {...formItemLayout} component={TextField} label="服務單位"
                       name="family_unit" type="text"></Field>
                <Field {...formItemLayout} component={TextField} label="職稱"
                       name="family_work_name" type="text"></Field>
                <Button htmlType="submit" type={'primary'} size={'large'}
                        style={{width: '100%', marginTop: '10px'}}>
                    送出
                </Button>
            </form>
        </Modal>
    )
}


FamilyMembersModal = reduxForm({
    form: 'FamilyMembersModalForm', // a unique identifier for this form
    enableReinitialize: true,
})(FamilyMembersModal)

const mapStateToProps = (state) => {
    return {
        modalIsOpen: state.getIn(['ModalData', 'modalIsOpen', 'family_members_modal']),
        modalName: state.getIn(['ModalData', 'modalName']),
        modalMsg: state.getIn(['ModalData', 'modalMsg']),
    }
}
const mapDispatchToPorps = (dispatch) => ({
    openModal: (payload) => (
        dispatch(openModal(payload))
    ),
    chageModal: (payload) => (
        dispatch(chageModal(dispatch, payload))
    ),
    closeModal: (payload) => (
        dispatch(closeModal(payload))
    ),
    editApplicationForAdmission: () => (
        dispatch(editApplicationForAdmission(dispatch))
    ),
    updateApplicationForAdmission: (payload) => (
        dispatch(updateApplicationForAdmission(dispatch, payload))
    ),
})

export default connect(mapStateToProps, mapDispatchToPorps)(FamilyMembersModal)


// WEBPACK FOOTER //
// ./src/dashboards_redux/containers/ApplicationForAdmissionContaioner/NewStudentForm/FamilyMembersModal.jsx